import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import 'App.css';
import Spinner from 'Common/Spinner';
import AmendContractDetailsColumns from './AmendContractDetailsColumns';
import PropTypes from 'prop-types';
import { withFuncCompTracking } from 'Telemetry/telemetry.service';

const AmendContractDetailsTable = (props, ref) => {
	let {
		selectedYear,
		keyField,
		apiCallCompleted,
		amendContractDetails,
		appointmentType,
		teamTitle,
		teamCode,
		amendmentDate,
		chkDeleteActionChecked
	} = props;
	const columns = AmendContractDetailsColumns();
	let btnAmendDetailsExportDisable = true;

	let btnAddDisable = true;
	let btnEditDisable = true;
	let btnDeleteDisable = true;
	let chkDeleteDisable = true;
	let btnAddDisplayText = 'Add Amendment';
	let btnEditDisplayText = 'Edit Amendment';
	let btnDeleteDisplayText = 'Delete Amendment';
	let lblDeleteDisplayText = 'I want to Delete Amendment';
	let lblTotalAmendmentReason = 'Total of added Amendment Reasons';
	let totalAmendmentReasons = 0;
	let amendContractDetailsLength = 0;
	let lblDeleteClass = 'amendLblDisable';
	let lblMaxAmendMsgClass = 'maxAmendMsgHide';

	if (apiCallCompleted === true) {
		amendContractDetailsLength = amendContractDetails && amendContractDetails.length;
		if (amendContractDetailsLength > 0) {
			btnEditDisplayText = btnEditDisplayText + ' ' + amendContractDetailsLength;
			btnDeleteDisplayText = btnDeleteDisplayText + ' ' + amendContractDetailsLength;
			lblDeleteDisplayText = lblDeleteDisplayText + ' ' + amendContractDetailsLength;
			btnEditDisable = false;
			btnAmendDetailsExportDisable = false;

			chkDeleteDisable = false;
			lblDeleteClass = 'amendLblEnable';
			if (chkDeleteActionChecked) btnDeleteDisable = false;
			else btnDeleteDisable = true;

			let arrAmendmentReasonIDs = [];
			amendContractDetails.forEach(item => {
				if (item.amendmentReasons) arrAmendmentReasonIDs = arrAmendmentReasonIDs.concat(item.amendmentReasonIds);
			});
			totalAmendmentReasons = arrAmendmentReasonIDs.length;
		} else btnAmendDetailsExportDisable = true;
		lblTotalAmendmentReason = lblTotalAmendmentReason + ': ' + totalAmendmentReasons + '.';

		let checkForNewAmendment = false;
		if (amendmentDate) {
			let currentDate = new Date();
			let lastAmendmentDate = new Date(amendmentDate);
			currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
			lastAmendmentDate = new Date(lastAmendmentDate.getFullYear(), lastAmendmentDate.getMonth(), lastAmendmentDate.getDate());
			if (lastAmendmentDate < currentDate) checkForNewAmendment = true;
		}
		if (amendContractDetailsLength === 0 || checkForNewAmendment) {
			btnAddDisable = false;
			btnEditDisable = true;
			btnDeleteDisable = true;
			chkDeleteDisable = true;
			lblDeleteClass = 'amendLblDisable';
		}
		if (amendContractDetailsLength === 6) btnAddDisable = true;
		if (amendContractDetailsLength === 6 && checkForNewAmendment) lblMaxAmendMsgClass = 'maxAmendMsgShow';
		else lblMaxAmendMsgClass = 'maxAmendMsgHide';
	}

	const PageCommonDetails = () => {
		return (
			<>
				<div className={'amendCmnHdrDtlsDiv'}>
					<label className={'amendCmnHdrDtlsLbl'}>{`${selectedYear} `}</label>
					<label className={'amendCmnHdrDtlsLbl'}>{`${teamTitle} `}</label>
					<label className={'amendCmnHdrDtlsLbl'}>{`Type: ${appointmentType} `}</label>
					<label className={'amendCmnHdrDtlsLbl'}>{`Code: ${teamCode}`}</label>
				</div>
			</>
		);
	};

	const PageButtons = () => {
		return (
			<>
				<button
					disabled={btnAddDisable}
					onClick={props.onAddClick}
					className="amendContractButton react-bs-table-csv-btn btn btn-default btn btn-primary btn-sm"
				>
					{btnAddDisplayText}
				</button>
				<button
					disabled={btnEditDisable}
					onClick={props.onEditClick}
					className="amendContractButton react-bs-table-csv-btn btn btn-default btn btn-primary btn-sm"
				>
					{btnEditDisplayText}
				</button>
			</>
		);
	};

	//_Customized Export.
	const ExportCSVButton = exportProps => {
		const handleClick = () => {
			props.getExportAmendContractDetails(exportProps);
		};
		return (
			<React.Fragment>
				<button
					disabled={btnAmendDetailsExportDisable}
					className="amendExportBtn react-bs-table-csv-btn btn btn-default btn-primary"
					onClick={handleClick}
				>
					Export CSV
				</button>
			</React.Fragment>
		);
	};

	return (
		<React.Fragment>
			<PageCommonDetails />
			<div>
				<ToolkitProvider
					keyField={keyField}
					data={amendContractDetails}
					columns={columns}
					exportCSV={{
						fileName: `contract_Management_${appointmentType}.csv`
					}}
				>
					{props => (
						<div>
							<BootstrapTable
								classes={'table tableStyle table-primary table-striped table-sm table-responsive-md'}
								bootstrap4
								striped
								condensed
								hover
								size="sm"
								{...props.baseProps}
							/>
							{!apiCallCompleted && <Spinner />}
							<label>{lblTotalAmendmentReason}</label>
							<label className={lblMaxAmendMsgClass}>Maximum number of Amendments reached.</label>
							<div className={'amendDtlsDiv'}>
								<ExportCSVButton {...props.csvProps} />
								<PageButtons />
							</div>
						</div>
					)}
				</ToolkitProvider>
			</div>
			<div className={'amendDeleteDiv'}>
				<button
					disabled={btnDeleteDisable}
					onClick={props.onDeleteClick}
					className="amendDeleteBtn react-bs-table-csv-btn btn btn-default btn btn-primary btn-sm"
				>
					{btnDeleteDisplayText}
				</button>
				<FormControlLabel
					className={lblDeleteClass}
					control={<Checkbox disabled={chkDeleteDisable} checked={chkDeleteActionChecked} onChange={event => props.onChangeDeleteCheckbox(event)} />}
					label={lblDeleteDisplayText}
				/>
			</div>
		</React.Fragment>
	);
};

AmendContractDetailsTable.propTypes = {
	selectedYear: PropTypes.number.isRequired,
	appointmentType: PropTypes.string.isRequired,
	teamTitle: PropTypes.string.isRequired,
	teamCode: PropTypes.string.isRequired
};

export default withFuncCompTracking('Amend Contract Details Table')(AmendContractDetailsTable);
